import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { TenantService } from '../tenants/tenant.service';
import { toDevProxyUrl } from './dev-proxy';

export const tenantBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantService = inject(TenantService);
  const devProxy = inject(ConfigService).devProxy;

  // Only intercept relative URLs that start with /api/
  if (req.url.startsWith('/api/')) {
    const tenant = tenantService.selectedTenant();

    if (!tenant) {
      throw new Error('No tenant selected. Please select a tenant before accessing this feature.');
    }

    // Clone the request with the full URL
    const modifiedReq = req.clone({
      url: toDevProxyUrl(`${tenant.apiUrl}${req.url}`, devProxy)
    });

    return next(modifiedReq);
  }

  // Pass through absolute URLs unchanged, unless they point at the proxied dev backend
  const proxiedUrl = toDevProxyUrl(req.url, devProxy);

  return proxiedUrl === req.url ? next(req) : next(req.clone({ url: proxiedUrl }));
};
